import React, { useState } from "react";
import "../../../../styles/full-view-popup.scss";
import { capitalizeAllFirstLettersOfWords, getPaymentStatus, LeadAssigneeChangeReason, ListHeaderDropdown, PaymentMethods } from "../../../../core";
import { DropdownList } from "react-widgets";
import moment from "moment";
import { InvoicePaymentHistory } from "./UploadInvoice";
import { format } from "date-fns";
import { Controller, UseFormMethods } from "react-hook-form";
import { RevertForm } from "./DocumentView";
import { UploadTabNames } from "./props";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { DownloadLink } from "../../../../components/render-file/DownloadLink";

enum Stages {
  initial ='initial',
  selectTransaction ='select transactions',
  transactionProcess ='transaction process',
  confirmationProcess ='confirmation process'
}

interface Customprops {
  onSubmit: (data: RevertForm) => Promise<void>;
  onClose: () => void;
  setSelectedTransactionIds: (data:string[]) => void;
  onAddTransaction: () => void;
  selectedTransactionIds: string[]
  changeReasons: LeadAssigneeChangeReason[];
  paymentHistory: InvoicePaymentHistory[];
  form: UseFormMethods<RevertForm>;
  mainTab?: UploadTabNames;
  currentFile: any;
  document: any;
}

const paymentMethods = [
  {
      name: "Cash",
      value: PaymentMethods.Cash,
  },
  {
      name: "Debit Card",
      value: PaymentMethods.DebitCard,
  },
  {
      name: "Credit Card",
      value: PaymentMethods.CreditCard,
  },
  // {
  //     name: "American Express",
  //     value: PaymentMethods.AmericanExpress,
  // },
  {
      name: "Bank Transfer",
      value: PaymentMethods.BankTransfer,
  },
  {
      name: "Cheque",
      value: PaymentMethods.Cheque,
  },
  // {
  //     name: "Web Payment",
  //     value: PaymentMethods.WebPayment,
  // },
  // {
  //     name: "Send Payment Link",
  //     value: "SendPaymentLink",
  // },
];

export const PaymentSummaryPopup: React.FunctionComponent<Customprops> = (
  props
) => {
  const [stage, setStage] = useState<Stages>(Stages.initial);
  const accountHolderName = [...new Set(props.paymentHistory.filter(item => props.selectedTransactionIds.includes(item._id)).map(item=>item.paidBy).filter(item=>item))].join(', ')


  const { control, watch } = props.form;
  const reason = watch("reason");
  const refundMethod = watch("refundMethod");
  const comment = watch("comment");

  const actions = [
    {
      text: "Add Payments",
      onClick: ()=> {props.onAddTransaction()}
    },
    {
      text: "Cancel/Revert Payment",
      onClick: ()=>{
        setStage(Stages.selectTransaction);
      }
    },
  ];

  const camelCaseToWords = (str:any)=>{
    return str.match(/^[a-z]+|[A-Z][a-z]*/g).map((x:any) => {
        return x[0].toUpperCase() + x.substr(1).toLowerCase();
    }).join(' ');
  };

  const amountPaid = ()=>{
    if(props.mainTab === UploadTabNames.InvoiceForCustomer){
        return props.currentFile?.document?.paymentDetails?.amountPaid
    }else if(props.mainTab === UploadTabNames.InvoiceForLandlord){
        return props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.amountPaid
    }else{
        return 0
    }
  }

  const pendingAmount =()=>{
    if(props.mainTab === UploadTabNames.InvoiceForCustomer){
        return ((props.currentFile?.document?.paymentDetails?.amount + props.currentFile?.document?.paymentDetails?.taxCgst + props.currentFile?.document?.paymentDetails?.taxSgst) - props.currentFile?.document?.paymentDetails?.amountPaid)
    }else if(props.mainTab === UploadTabNames.InvoiceForLandlord){
        return ((props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.amount + props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.taxCgst + props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.taxSgst) - props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.amountPaid)
    }else{
        return 0
    }
  }   
  const refundAmount = () => {
    if(props.mainTab === UploadTabNames.InvoiceForCustomer){
      return (props.currentFile?.document?.paymentDetails?.totalRefundAmount)
    }else if(props.mainTab === UploadTabNames.InvoiceForLandlord){
      return (props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.totalRefundAmount)
    }else{
        return 0
    }
  }   

  const getStatus = () => {
    if (props.document?.internalApproval?.status === "Approved") {
      return "Internally Approved";
    }
    if (props.document?.internalApproval?.status === "Rejected") {
      return "Internally Rejected";
    }
    if (props.document?.internalApproval?.status === "Pending") {
      return "Internal Approval Pending";
    }
    return "Draft";
  };
  return (
    <div className="modal-open">
      <form onSubmit={props.form.handleSubmit(props.onSubmit)}>
      <div
        className="detail-poupup bg-white position-fixed top-0  h-100 overflow-auto in"
        style={{ width: "98%" }}
      >
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-99">
          <div className="row align-items-center">
            <div
              className="col-auto"
              onClick={() => {
                props.onClose();
               props.setSelectedTransactionIds([])
              }}
            >
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
            {props.currentFile?.proposedPropertyDetails.map((element: any,  index: number) => (
              <>
                <div className=" d-flex align-items-center">
                  <label className="font-md font-weight-semibold mb-0 ">
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.projectName
                    }{" "}
                    / Floor :{" "}
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.floor
                    }{" "}
                    / Unit :{" "}
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.unitName
                    }{" "}
                    / Area :{" "}
                    {
                      element?.propertyDetails
                        ?.propertyDetailsFromProject?.area
                    }
                  </label>
                  {!!(props.currentFile.proposedPropertyDetails.length === index + 1) && <>
                  {!props.document?.clientApproval && !props.document?.landlordApproval ? (
                    <span
                      className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                    >
                      {getStatus()}
                    </span>
                  ) : (
                    <>
                      {props.document?.paymentDetails?.paymentStatus === "Paid" || props.document?.paymentDetails?.paymentStatus === "PaymentCollection" ? (
                        <span
                          className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                        >
                          {props.document?.paymentDetails?.paymentStatus === "PaymentCollection" ?
                          "Payment in Progress" : "Payment Collected"}
                        </span>
                      ) :
                      <>
                       {!!props.document?.clientApproval &&
                        props.document?.paymentDetails?.paymentStatus !== "Paid" && (
                          <span
                            className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                          >
                            {props.document?.clientApproval.status === "Pending"
                              ? "Sent to Client"
                              : "Client Approved"}
                          </span>
                        )}
                       {!!props.document?.landlordApproval &&
                        props.document?.paymentDetails?.paymentStatus !== "Paid" && (
                          <span
                            className={`bg-white font-sm px-2 py-1 requirement-title tag--pending border-primary border text-primary rounded-sm ml-3`}
                          >
                            {props.document?.landlordApproval.status === "Pending"
                              ? "Sent to Owner"
                              : "Vendor/Owner Approved"}
                          </span>
                        )}
                      </>
                      }
                    </>
                  )}
                   </>}
                </div>
                {!!(props.currentFile.proposedPropertyDetails.length === index + 1) &&<span className="d-block  font-xs text-gray-500 font-weight-semibold">
                  Created By{" "}
                  <span className="text-dark">
                    {props.currentFile?.createdBy?.name}
                  </span>{" "}
                  on{" "}
                  <span className="text-dark">
                    {moment(props.mainTab === UploadTabNames.InvoiceForCustomer ?  props.currentFile?.document?.createdAt : props.currentFile?.seperateDocumentForLandlord?.createdAt).format(
                      "DD MMM YYYY hh:mm A"
                    )}
                  </span>
                </span>}
              </>
            ))}
            </div>
          </div>
        </div>
        <div className="payment-summary-pop-outer">
          <h2 className="font-weight-semibold pb-3">Payment Summary</h2>

          <div className="row">
            <div className="col-7">
              <ul className="list-unstyled">
              <li>
                  <label className="block font-xs">Invoice Gross Amount </label>
                  <span className="font-weight-bold">₹{(props.document?.paymentDetails?.amount + props.document?.paymentDetails?.taxCgst + props.document?.paymentDetails?.taxSgst).toLocaleString('en-IN')}</span>
                </li>
                <li>
                  <label className="block font-xs">Total Paid</label>
                  <span className="font-weight-bold">₹{amountPaid().toLocaleString('en-IN')  || 0}</span>
                </li>
                <li>
                  <label className="block font-xs">Refund amount</label>
                  <span className="font-weight-bold">₹{refundAmount().toLocaleString('en-IN')  || 0}</span>
                </li>
                <li>
                  <label className="block font-xs">Balance to Pay</label>
                  <span className="font-weight-bold">₹{pendingAmount().toLocaleString('en-IN')  || 0}</span>
                </li>

              </ul>
            </div>
            <div className="col-5 d-flex justify-content-end align-items-center">
              <ListHeaderDropdown text="Action" actions={actions} />
            </div>
          </div>

          {stage === Stages.selectTransaction &&<div
            className="border-top pt-4 mt-2 pb-5"
            style={{ margin: "0 -30px", padding: "0 30px" }}
          >
            <h4 className="font-base font-weight-semibold font-lg   font-weight-semibold pb-2 pt-2">
              Select Cancel /Revert Amount
            </h4>
            <div className="common-transation-table ">
              <table style={{ width: "75%" }}>
                <thead>
                  <tr>
                    <th style={{ width: "5%" }}>
                      <div>
                        <input
                            type="checkbox"
                            name="check-all"
                            id={'select-All'}
                            checked={props.paymentHistory.every(obj => props.selectedTransactionIds.includes(obj._id))}
                            onChange={()=> {
                              if(props.paymentHistory.every(obj => props.selectedTransactionIds.includes(obj._id))){
                                props.setSelectedTransactionIds([])
                              }else{
                                const tempArray =  [...props.selectedTransactionIds, ...props.paymentHistory.map(obj => obj._id)]
                                props.setSelectedTransactionIds([...new Set(tempArray)])
                              }
                            }}
                         
                        />
                        <label htmlFor="select-All"></label>
                      </div>
                    </th>
                          <th>Payment Method</th>
                          <th>Amount </th>
                          <th>Payment Date</th>
                          <th>Paid By  </th>
                          <th>Comment  </th>
                          <th>Bank</th>
                          {/* <th>Receipt</th> */}
                          <th>Transaction Recorded By </th>
                          <th>Transaction Recorded On </th>
                          <th>Status  </th>
                          <th>Download</th>
                          {/* <th>Cancelled Reason  </th> */}
                  </tr>
                </thead>
                <tbody>
                    {[...(props?.paymentHistory.filter(item=>item.isRefunded === false) || [])].reverse()?.map((item:InvoicePaymentHistory)=> <tr key={item._id}>
                      <td>
                      <div>
                        <input
                          type="checkbox"
                          name="checkprop-undefined"
                          id={item._id}
                          checked={props.selectedTransactionIds.includes(item._id)}
                          onChange={()=> {
                            if(props.selectedTransactionIds.includes(item._id)){
                              const tempArray = props.selectedTransactionIds.filter(s=>s!== item._id)
                              props.setSelectedTransactionIds(tempArray)
                            }else{
                              const tempArray = [...props.selectedTransactionIds, item._id]
                              props.setSelectedTransactionIds(tempArray)
                            }
                          }}
                        />
                        <label htmlFor={item._id}></label>
                      </div>
                    </td>
                          <td>
                            <span>{camelCaseToWords(capitalizeAllFirstLettersOfWords(item.paymentMethod))}</span>
                            {/* <span className="text-xs d-block font-xxs pt-1 text-muted">
                              31/May/2021 6:14 PM
                            </span> */}
                          </td>
                          <td>₹{item.amount.toLocaleString('en-IN')}</td>
                          <td>{moment(item.paidAt).format("DD/MMM/YYYY")} </td>
                          <td>{item.paidBy}</td>
                          <td>{item.comments}</td>
                          <td>{item.bank}</td>
                          {/* <td>
                            {item.receipt && <DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink>}
                          </td> */}
                          <td>{item?.addedBy?.name}</td>
                          <td>{moment(item.createdAt).format("DD/MMM/YYYY hh:mm A")}</td>
                          <td>{getPaymentStatus(item.status)}</td>
                          <td><DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink></td>
                          {/* <td>{item.reason}</td> */}
                        </tr>)}
                </tbody>
              </table>
              <div className="mt-4">
                <button className="btn btn-primary font-normal font-weight-semibold px-5 rounded-0 mr-3"
                onClick={()=>{
                  if(props.selectedTransactionIds.length > 0){
                    setStage(Stages.transactionProcess);
                  }
                }}>
                  Proceed
                </button>
                <button className="btn btn-outline-primary font-normal font-weight-semibold px-5 rounded-0" onClick={()=>{
                  setStage(Stages.initial);
                  props.setSelectedTransactionIds([])
                }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>}

          {(stage === Stages.transactionProcess || stage === Stages.confirmationProcess) && (
            <div
              className="border-top pt-4 mt-2 pb-5"
              style={{
                margin: "0 -30px",
                padding: "0 30px",
                backgroundColor: "#FDFDFD",
              }}
            >
              <h4 className="font-base font-weight-semibold font-lg font-weight-semibold pb-2 pt-2">
                Cancel /Revert Payment Process
              </h4>

              <h6 className="font-base font-weight-semibold font-base font-weight-semibold pb-2 pt-2">
                Linked to Transactions
              </h6>

                   {stage === Stages.confirmationProcess && <div className="common-transation-table"> <table>
                      <thead>
                        <tr>
                          <th>Payment Method</th>
                          <th>Amount </th>
                          <th>Payment Date</th>
                          <th>Paid By  </th>
                          <th>Comment  </th>
                          <th>Bank</th>
                          {/* <th>Receipt</th> */}
                          <th>Transaction Recorded By </th>
                          <th>Transaction Recorded On </th>
                          <th>Status  </th>
                          <th>Cancelled Reason  </th>
                          <th>Download</th>
                        </tr>
                      </thead>
                      <tbody>
                       {[...(props?.paymentHistory.filter((item:InvoicePaymentHistory)=>props.selectedTransactionIds.includes(item._id)) || [])].reverse()?.map((item:InvoicePaymentHistory)=> <tr>
                          <td>
                            <span>{camelCaseToWords(capitalizeAllFirstLettersOfWords(item.paymentMethod))}</span>
                            {/* <span className="text-xs d-block font-xxs pt-1 text-muted">
                              31/May/2021 6:14 PM
                            </span> */}
                          </td>
                          <td>₹{item.amount.toLocaleString('en-IN')}</td>
                          <td>{moment(item.paidAt).format("DD/MMM/YYYY")} </td>
                          <td>{item.paidBy}</td>
                          <td>{item.comments}</td>
                          <td>{item.bank}</td>
                          {/* <td>
                            {item.receipt && <DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink>}
                          </td> */}
                          <td>{item?.addedBy?.name}</td>
                          <td>{moment(item.createdAt).format("DD/MMM/YYYY hh:mm A")}</td>
                          <td>{getPaymentStatus(item.status)}</td>
                          <td>{item.reason}</td>
                          <td><DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink></td>
                        </tr>)}
                      </tbody>
                    </table></div>}

              {(<div className={stage === Stages.transactionProcess? 'common-transation-table' :" d-none"}>
                    <table>
                      <thead>
                        <tr>
                          <th>Payment Method</th>
                          <th>Amount </th>
                          <th>Payment Date</th>
                          <th>Paid By  </th>
                          <th>Comment  </th>
                          <th>Bank</th>
                          {/* <th>Receipt</th> */}
                          <th>Transaction Recorded By </th>
                          <th>Transaction Recorded On </th>
                          <th>Status  </th>
                          <th>Cancelled Reason  </th>
                          <th>Download</th>
                        </tr>
                      </thead>
                      <tbody>
                       {[...(props?.paymentHistory.filter((item:InvoicePaymentHistory)=>props.selectedTransactionIds.includes(item._id)) || [])].reverse()?.map((item:InvoicePaymentHistory)=> <tr>
                          <td>
                            <span>{camelCaseToWords(capitalizeAllFirstLettersOfWords(item.paymentMethod))}</span>
                            {/* <span className="text-xs d-block font-xxs pt-1 text-muted">
                              31/May/2021 6:14 PM
                            </span> */}
                          </td>
                          <td>₹{item.amount.toLocaleString('en-IN')}</td>
                          <td>{moment(item.paidAt).format("DD/MMM/YYYY")} </td>
                          <td>{item.paidBy}</td>
                          <td>{item.comments}</td>
                          <td>{item.bank}</td>
                          {/* <td>
                            {item.receipt && <DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink>}
                          </td> */}
                          <td>{item?.addedBy?.name}</td>
                          <td>{moment(item.createdAt).format("DD/MMM/YYYY hh:mm A")}</td>
                          <td>{getPaymentStatus(item.status)}</td>
                          <td>{item.reason}</td>
                          <td><DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink></td>
                        </tr>)}
                      </tbody>
                    </table>
                    <div className="linked-transation-form mt-4 pt-1">
                      <form>
                        <div className="form-group">
                          <label>Reason for Refund</label><span className="text-danger">*</span>
                          <Controller
                            name="reason"
                            rules={{
                              required: true
                            }}
                            control={control}
                            render={( field ) => (
                              <DropdownList
                                {...field}
                                placeholder="Reason for Refund"
                                textField={"reason"}
                                valueField={"_id"}
                                data={props.changeReasons}
                              />
                            )}
                          />
                          {props.form?.errors?.reason && (
                                      <ErrorMessage>
                                        Reason for Refund
                                      </ErrorMessage>
                            )}
                        </div>

                        <div className="form-group">
                          <label>Refund Amount</label>
                          <input
                            className="form-control"
                            type="text"
                            disabled
                            value={props.paymentHistory.filter(item => props.selectedTransactionIds.includes(item._id)).reduce((acc, curr) => { return acc + curr.amount }, 0)}
                          />
                        </div>

                        <div className="form-group">
                          <label>Refund Method</label>
                          <Controller
                            name="refundMethod"
                            control={control}
                            render={( field ) => (
                              <DropdownList
                                {...field}
                                data={paymentMethods}
                                textField={"name"}
                                valueField={"value"}
                                placeholder={"Payment Method"}
                                filter={"contains"}
                              />
                            )}
                          />
                        </div>
                        <div className="form-group">
                          <label>Comment</label>
                          <Controller
                            name="comment"
                            control={control}
                            render={( field ) => (
                              <textarea className="form-control" {...field} />
                            )}
                          />
                        </div>
                        <div className="mt-4">
                          <button
                            type="button"
                            className="btn btn-primary font-normal font-weight-semibold px-5 rounded-0 mr-3"
                            onClick={() => {
                                props.form.trigger().then((res) => {
                                if(res){
                                  setStage(Stages.confirmationProcess);
                                }
                              });
                            }}
                          >
                            Proceed
                          </button>
                          <button
                            className="btn btn-outline-primary font-normal font-weight-semibold px-5 rounded-0 mr-3 small"
                            onClick={() => {
                              setStage(Stages.initial);
                              props.setSelectedTransactionIds([])
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-outline-primary font-normal font-weight-semibold px-5 rounded-0 small"
                            onClick={() => {
                              setStage(Stages.selectTransaction);
                            }}
                          >
                            Previous
                          </button>
                        </div>
                      </form>
                    </div>
                </div>
              )}

              {stage === Stages.confirmationProcess && (
                <div className="linked-transation-form mt-4 pt-1">
                  <div className="entered-area mt-2">
                    <div className="form-group">
                      <label>Reason for Refund</label>
                      <span className="font-normal d-block">{reason?.reason}</span>
                    </div>

                    <div className="form-group">
                      <label>Refund Amount</label>
                      <span className="font-normal d-block">₹{props.paymentHistory.filter(item => props.selectedTransactionIds.includes(item._id)).reduce((acc, curr) => { return acc + curr.amount }, 0)}</span>
                    </div>

                    {refundMethod?.name &&<div className="form-group">
                      <label>Refund Method</label>
                      <span className="font-normal d-block">{refundMethod?.name}</span>
                    </div>}

                   {accountHolderName && <div className="form-group">
                      <label>Account Holder's Name</label>
                      <span className="font-normal d-block">{accountHolderName}</span>
                    </div>}

                    <div className="form-group">
                      <label>Date of Refund</label>
                      <span className="font-normal d-block">{format(new Date(), "dd/MM/yyyy")}</span>
                    </div>

                    {comment&&<div className="form-group">
                      <label>Comment</label>
                      <span className="font-normal d-block">{comment}</span>
                    </div>}

                    <div className="mt-4 pt-3">
                      <button
                      type="submit"
                        className="btn btn-primary font-normal font-weight-semibold px-5 rounded-0 mr-3"
                       
                      >
                        Send Refund Request
                      </button>
                      <button
                        className="btn btn-outline-primary font-normal font-weight-semibold px-5 rounded-0 mr-3 small"
                        onClick={() => {
                          setStage(Stages.initial);
                          props.setSelectedTransactionIds([])
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-outline-primary font-normal font-weight-semibold px-5 rounded-0 small"
                        onClick={() => {
                          setStage(Stages.transactionProcess);
                        }}
                      >
                        Previous
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          <div
            className="border-top pt-4 mt-2"
            style={{ margin: "0 -30px", padding: "0 30px" }}
          >
            <h4 className="font-base font-weight-semibold font-base font-weight-semibold pb-2 pt-2">
              Transaction History
            </h4>
            <div className="common-transation-table ">
            <table>
                      <thead>
                        <tr>
                          <th>Payment Method</th>
                          <th>Amount </th>
                          <th>Payment Date</th>
                          <th>Paid By  </th>
                          <th>Comment  </th>
                          <th>Bank</th>
                          {/* <th>Receipt</th> */}
                          <th>Transaction Recorded By </th>
                          <th>Transaction Recorded On </th>
                          <th>Status  </th>
                          <th>Cancelled Reason  </th>
                          <th>Download</th>
                        </tr>
                      </thead>
                      <tbody>
                       {[...(props?.paymentHistory || [])].reverse()?.map((item:InvoicePaymentHistory)=> <tr>
                          <td>
                            <span>{camelCaseToWords(capitalizeAllFirstLettersOfWords(item.paymentMethod))}</span>
                            {/* <span className="text-xs d-block font-xxs pt-1 text-muted">
                              31/May/2021 6:14 PM
                            </span> */}
                          </td>
                          <td>₹{item.amount.toLocaleString('en-IN')}</td>
                          <td>{moment(item.paidAt).format("DD/MMM/YYYY")} </td>
                          <td>{item.paidBy}</td>
                          <td>{item.comments}</td>
                          <td>{item.bank}</td>
                          {/* <td>
                            {item.receipt && <DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink>}
                          </td> */}
                          <td>{item?.addedBy?.name}</td>
                          <td>{moment(item.createdAt).format("DD/MMM/YYYY hh:mm A")}</td>
                          <td>{getPaymentStatus(item.status)}</td>
                          <td>{item.reason}</td>
                          <td><DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                             {item.receipt ? 'View' : ''}                                </DownloadLink></td>
                        </tr>)}
                        <tr>
                        <td
                          colSpan={10}
                          style={{
                            border: "0",
                            padding: 0,
                            backgroundColor: "#F5F6F8",
                          }}
                        >
                          <table style={{ border: "0", width: "50%" }}>
                            <tbody>
                              <tr style={{ border: "0" }}>
                                <td
                                  align="left"
                                  width="19%"
                                  style={{ border: "0" }}
                                  className="font-weight-bold"
                                >
                                  Total
                                </td>
                                <td style={{ border: "0" }}>
                                  <table style={{ border: "0" }}>
                                    <tbody>
                                      <tr style={{ border: "0" }}>
                                        <td
                                          style={{ border: "0", padding: 0 }}
                                          className="font-weight-bold pl-1"
                                        >
                                          ₹{(amountPaid()).toLocaleString('en-IN')  || 0}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      </tbody>
                    </table>
            </div>
          </div>
        </div>
      </div>
      </form>
      <div className="modal-backdrop fade show"></div>
    </div>
  );
};